import React from "react";

const Stepper = ({ activeTab, steps }) => {
  return (
    <div className="w-100 d-flex justify-content-center mb-3">
      <div
        className="d-flex align-items-center"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            {/* Step */}
            <div
              className="text-center position-relative z-3"
              onClick={() => step?.onClickStep()}
              role="button"
              style={{ minWidth: "80px" }}
            >
              <div
                className={`step-pill mx-auto mb-2 fs-6 fw-bold rounded-circle ${
                  activeTab >= index + 1
                    ? "text-white bg-primary"
                    : "inactive-pill text-muted border border-2"
                }`}
                // style={{ width: "25px", height: "25px", lineHeight: "40px" }}
              ></div>
              <div className="step-description text-dark">
                <div className="rv-sub-label rv-label-muted">
                  Step {index + 1}
                </div>
                <div>{step?.desc}</div>
              </div>
            </div>

            {/* Line (only render between steps) */}
            {index < steps.length - 1 && (
              <div
                className="flex-grow-1 position-relative"
                style={{ marginLeft: "-20px", marginRight: "-20px" }}
              >
                {/* background line */}
                <div
                  //   className="stepper-line-bg"
                  style={{
                    height: "4px",
                    backgroundColor: "#FD7545",
                    borderRadius: "2px",
                    marginTop: "-30px",
                    opacity: "0.5",
                  }}
                />
                {/* progress line */}
                <div
                  className="stepper-line-progress"
                  style={{
                    height: "4px",
                    // backgroundColor: "#007bff",
                    borderRadius: "2px",
                    marginTop: "-45px",
                    width: activeTab > index + 1 ? "100%" : "0%",
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
